module.exports = __webpack_public_path__ + "static/media/1B.77ff1e3a.png";